import React from "react";
import Requirement from "./requirement";
import Header from '../header';

const RequirementMain = props => {

    return (
        <div className="App">
            <Header/>
            <Requirement props={props}/>
        </div>
    )
}

export default RequirementMain;